document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.cat-hover-menu').forEach(function (menu) {
    let closeTimer = null;

    function openMenu() {
      clearTimeout(closeTimer);
      menu.classList.add('is-open');
    }

    function scheduleClose() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        menu.classList.remove('is-open');
      }, 300);
    }

    menu.addEventListener('mouseenter', openMenu);
    menu.addEventListener('mouseleave', scheduleClose);

    const panel = menu.querySelector('.cat-hover-menu__panel');
    if (panel) {
      panel.addEventListener('mouseenter', openMenu);
      panel.addEventListener('mouseleave', scheduleClose);
    }

    const leftItems = menu.querySelectorAll('.cat-hover-menu__col-left-item');
    const panels = menu.querySelectorAll('.cat-hover-menu__panel-detail');

    leftItems.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        const index = item.getAttribute('data-cat-index');
        leftItems.forEach((i) => i.classList.remove('is-active'));
        panels.forEach((p) => p.classList.remove('is-active'));
        item.classList.add('is-active');
        const targetPanel = menu.querySelector(
          '.cat-hover-menu__panel-detail[data-cat-panel="' + index + '"]'
        );
        if (targetPanel) targetPanel.classList.add('is-active');
      });
    });
  });
});